// Menu item types
const MENU_ITEM_TYPE = {
    ACTION: 'ACTION',      // Click to trigger action directly
    SUBMENU: 'SUBMENU',    // Click to show submenu
    TOGGLE: 'TOGGLE'       // Toggle switch item
};

// Menu item keys - used to identify which action to trigger
const MENU_ITEM_KEY = {
    AI_CHAT_MENU_UPLOAD_FILE: 'AI_CHAT_MENU_UPLOAD_FILE',
    AI_CHAT_MENU_UPLOAD_IMAGE: 'AI_CHAT_MENU_UPLOAD_IMAGE',
    AI_CHAT_MENU_CAPTURE_IMAGE: 'AI_CHAT_MENU_CAPTURE_IMAGE',
    AI_CHAT_MENU_MCP_SETTING: 'AI_CHAT_MENU_MCP_SETTING',
    AI_CHAT_MENU_KIBANA_ANALYSIS: 'AI_CHAT_MENU_KIBANA_ANALYSIS',
    AI_CHAT_MENU_CHAT_AI_SETTING: 'AI_CHAT_MENU_CHAT_AI_SETTING',
    AI_CHAT_MENU_USING_REFERENCE_KNOWLEDGE: 'AI_CHAT_MENU_USING_REFERENCE_KNOWLEDGE',
    AI_CHAT_MENU_AI_LOG_DETAIL: 'AI_CHAT_MENU_AI_LOG_DETAIL',
    AI_CHAT_MENU_CONNECT_KBOARD: 'AI_CHAT_MENU_CONNECT_KBOARD',
};

export {
    MENU_ITEM_TYPE,
    MENU_ITEM_KEY
};
